import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Container, Row, Col, ButtonGroup, Button } from 'reactstrap';

import config from '../../../../config';

import { getProductPrice, getProductMatchingPack } from '../../../Product/ProductActions';
import { getCartItems, setCartItem } from '../../CartActions';
import { getTaxesRequest } from '../../../Tax/TaxActions';
import { getShippingFeesRequest } from '../../../ShippingFee/ShippingFeeActions';
import { getPublicVouchersRequest, checkVoucherConditionsFromStore, applyVoucher } from '../../../Voucher/VoucherActions';
import { getTranslation, getLanguagePath } from '../../../Intl/IntlActions';

import FileLoader from '../../../../components/Content/FileLoader';
import FontCustom from '../../../../components/Content/FontCustom';

import Price from '../../../Currency/components/view/Price';
import CartProgress from '../../components/view/CartProgress';
import CartPreview from '../../components/view/CartPreview';
import CartShipping from '../../components/view/CartShipping';
import CartPayment from '../../components/view/CartPayment';
import CartConfirmation from '../../components/view/CartConfirmation';


class CartPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: props.match.params.step || 'preview',
        };
    }

    static getDerivedStateFromProps(props, state) {
        if(props.match.params.step !== state.step) {
            return { step: props.match.params.step || 'preview' };
        }
        return null;
    }

    componentDidMount() {
        this.props.dispatch(getTaxesRequest());
        this.props.dispatch(getShippingFeesRequest());
        this.props.dispatch(getPublicVouchersRequest()).then(vouchers => {
            const autoVoucher = vouchers.find(voucher => voucher.isAuto && checkVoucherConditionsFromStore(this.props.store, voucher));
            if(autoVoucher) {
                this.props.dispatch(applyVoucher(autoVoucher));
            }
        });
    }

    goToPreviousStep = () => {
        let previousStep = '';
        switch(this.state.step) {
            case 'shipping':
                previousStep = 'preview';
                break;

            case 'payment':
                previousStep = 'shipping';
                break;

            case 'confirmation':
                previousStep = 'payment';
                break;

            case 'preview':
            default:
                return null;
        }
        previousStep && this.props.history.push(getLanguagePath(`/cart/${previousStep}`, this.props.intl.locale));
        // previousStep && this.setState({ step: previousStep });
    }

    goToNextStep = (event, orderId = null) => {
        console.log('goToNextStep', this.state.step, this.props.match.params.step);
        let nextStep = '';
        switch(this.state.step) {
            case 'preview':
                nextStep = 'shipping';
                break;

            case 'shipping':
                nextStep = 'payment';
                break;

            case 'payment':
                nextStep = 'confirmation';
                break;


            case 'confirmation':
            default:
                return null;
        }
        console.log(nextStep);
        nextStep && this.props.history.push(getLanguagePath(`/cart/${nextStep}${orderId ? `/${orderId}` : ''}`, this.props.intl.locale));
        // nextStep && this.setState({ step: nextStep });
    }

    goToStep = step => {
        step && this.props.history.push(getLanguagePath(`/cart/${step}`, this.props.intl.locale));
    }

    renderStep() {
        const stepProps = {
            goToNextStep: this.goToNextStep,
            locale: this.props.intl.locale,
        };

        switch(this.state.step) {
            case 'shipping':
                return <CartShipping {...stepProps} />;

            case 'payment':
                return <CartPayment {...stepProps} />;

            case 'confirmation':
                return <CartConfirmation {...stepProps} orderId={this.props.match.params.orderId} />;

            case 'preview':
            default:
                // return <CartShipping {...stepProps} />;
                return <CartPreview {...stepProps} />;
        }
    }

    render() {
        return (
            <Container fluid className="bg-light">
                <Container className="bg-custom-plant inverted">

                    <CartProgress step={this.state.step} goToStep={this.goToStep} />

                    <Row>
                        <Col xs="12" md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
                            {this.renderStep()}
                        </Col>
                    </Row>

                    {false && process.env.NODE_ENV === 'development' && (
                        <ButtonGroup>
                            <Button onClick={this.goToPreviousStep}>Prev</Button>
                            <Button onClick={this.goToNextStep}>Next</Button>
                        </ButtonGroup>
                    )}

                    <div className="py-5 d-flex justify-content-center text-primary">
                        <div className="pt-3"><FontCustom name="contact" size="5" /></div>
                        <div>
                            <span className="text-lg"><FormattedMessage id="contactNeedHelpTitle" defaultMessage="Need help?" /></span><br />
                            <span><FormattedMessage id="contactUsByPhone" defaultMessage="Contact us on" /></span><br />
                            <a href={`tel:${config.application.phone}`} className="text-lg"><strong>{config.application.phone}</strong></a>
                        </div>
                    </div>
                </Container>
            </Container>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        store,
    };
}

CartPage.defaultProps = {
};

CartPage.propTypes = {
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
};

export default connect(mapStateToProps)(injectIntl(CartPage));
